
<h3>{{'DISPATCH.CERTIFICAR2.INST_UPD_URL_NAME' | translate}}</h3>


  <mat-form-field class="example-full-width">
    <input matInput #message maxlength="{{caracteresNombreUrl}}" [(ngModel)]="name">
    <mat-hint align="start"><strong></strong> </mat-hint>
    <mat-hint align="end">{{message.value.length}} / {{caracteresNombreUrl}}</mat-hint>
  </mat-form-field>

<div class=""fxLayout="row" fxLayoutAlign="center center">
  <button mat-raised-button style="width:40%" color="primary" (click)="actualizarNombreUrl(name)" >{{'DISPATCH.CERTIFICAR2.BTN_UPD_GUARDA' | translate}}</button>
  <button mat-raised-button style="width:40%" color="accent" (click)="onClose()" >{{'DISPATCH.CERTIFICAR2.BTN_UPD_CAN' | translate}}</button>

</div>
